import React from 'react'

export default function PageTitle({ title }) {
    return (
        <div className='w-fit'>
            <h1 className='font-bold text-3xl'>{title}</h1>
            <span className='block bg-[#0369E4] h-[0.2rem] w-[50%] rounded-2xl mt-1'></span>
        </div>
    );
}
